module.exports = __webpack_public_path__ + "media/images/emblems/Eschenz-bb8355fac08bf2ac1050d8676a9c7e2f.GIF";